export {newElement};

/**
 * 
 * @param {string} tagType DOM tag type to create
 * @param {mixed} classes [string|array] class(es) to apply to new element
 * @param {string} textContent text to insert into new element
 * @returns {Element} DOM element
 */
function newElement( tagType, classes, textContent ){
	let blank = document.createElement( tagType );
	
	if( typeof classes === 'object' ){ // really, an array
		classes.forEach( thisClass => {
			blank.classList.add( thisClass );
		});
	}
	else if( typeof classes == 'string' ){
		blank.classList.add( classes );
	}

	if( typeof textContent == 'string' ){
		blank.appendChild( document.createTextNode( textContent ) );
	}

	return blank;
}
